module.exports = __webpack_public_path__ + "img/themes2.e8db38d0.jpg";